import React from 'react';
import LinkWrapper from './linkWrapper/LinkWrapper';
import { prepareRichText, decodeText } from '../../utils/richText';

const HEADING_TAGS = ['h1', 'h2', 'h3'];

// The dialog reuses the corporate text-size option list (Tailwind tokens); map them to the
// component's own modifier classes so the storefront does not depend on Tailwind.
const TEXT_SIZES = { 'text-lg': 'lg', 'text-base': 'base', 'text-sm': 'sm', 'text-xs': 'xs' };

// Headline & Text content component, the ecom twin of demo-ftl-base's headlineAndText:
// eyebrow, title (its size doubles as the heading level), optional subtitle, rich-text body
// and one CTA. Styles live in assets/scss/_headline-text.scss.
const Headline = ({ eyebrow, title, subtitle, text, link = {}, titleTag, alignment, textSize }) => {
  // Render the heading tag the author picked so the page outline stays intact (default h2).
  const TitleTag = HEADING_TAGS.includes(titleTag) ? titleTag : 'h2';
  const body = prepareRichText(text);
  const bodySize = TEXT_SIZES[textSize] || 'base';
  const label = decodeText(link.label);

  return (
    <div className={`headline-text ${alignment === 'text-center' ? 'text-center' : 'text-start'}`}>
      {eyebrow && <span className="headline-text__eyebrow">{decodeText(eyebrow)}</span>}
      {title && <TitleTag className="headline-text__title">{decodeText(title)}</TitleTag>}
      {subtitle && <p className="headline-text__subtitle">{decodeText(subtitle)}</p>}
      {body && <div className={`headline-text__body headline-text__body--${bodySize}`} dangerouslySetInnerHTML={{ __html: body }} />}
      {label && (
        <div className="headline-text__cta btn-hover">
          <LinkWrapper linkNode={link} linkClass="default-btn">
            {label}
          </LinkWrapper>
        </div>
      )}
    </div>
  );
};

export default Headline;